module.exports = __webpack_public_path__ + "img/Sharing3.3a591951.svg";